// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-k"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 19V5M16 19V17.2573C16 17.0958 15.922 16.9443 15.7906 16.8504L9.5 12.3571M16 5V6.74269C16 6.90417 15.922 7.0557 15.7906 7.14956L9.5 11.6429","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersKIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-k',
    ref,
    icon: element,
  },
));

LettersKIcon.displayName = 'LettersKIcon';

export default LettersKIcon;
